module.exports = __webpack_public_path__ + "img/header-icon-1.4cd439a1.png";